import React, { useCallback, useEffect, useState } from 'react';
import { Button, Select, Space, Table, Typography, message } from 'antd';
import { DownloadOutlined, SyncOutlined } from '@ant-design/icons';
import { downloadOpsFaturasCsv, getOpsFaturas, syncOpsFaturas } from '../../services/opsService';

const { Title } = Typography;

const formatCurrency = (v) =>
  Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

const STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'pagas', label: 'Pagas' },
  { value: 'pendentes', label: 'Pendentes' },
  { value: 'vencidas', label: 'Vencidas' },
];

export default function OpsFaturasPage() {
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [status, setStatus] = useState('');
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], total: 0 });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const result = await getOpsFaturas({
        status: status || undefined,
        page,
        page_size: 25,
      });
      setData(result);
      if (result.sync_auto_count > 0) {
        message.info(`${result.sync_auto_count} fatura(s) importada(s) automaticamente do Asaas.`);
      }
    } finally {
      setLoading(false);
    }
  }, [status, page]);

  useEffect(() => {
    load();
  }, [load]);

  const handleSync = async () => {
    setSyncing(true);
    try {
      const result = await syncOpsFaturas();
      message.success(`${result.synced} pagamento(s) sincronizado(s).`);
      load();
    } catch {
      message.error('Falha ao sincronizar com o Asaas.');
    } finally {
      setSyncing(false);
    }
  };

  const columns = [
    { title: 'Usuário', dataIndex: 'usuario_email', key: 'usuario_email' },
    { title: 'Plano', dataIndex: 'plano', key: 'plano' },
    { title: 'Bruto', dataIndex: 'valor_bruto', key: 'valor_bruto', render: formatCurrency },
    { title: 'Líquido', dataIndex: 'valor_liquido', key: 'valor_liquido', render: formatCurrency },
    { title: 'Status', dataIndex: 'status_label', key: 'status_label' },
    { title: 'Forma', dataIndex: 'billing_type_label', key: 'billing_type_label' },
    { title: 'Vencimento', dataIndex: 'data_vencimento', key: 'data_vencimento' },
    { title: 'Pagamento', dataIndex: 'data_pagamento', key: 'data_pagamento' },
    {
      title: 'Fatura',
      key: 'invoice',
      render: (_, row) =>
        row.invoice_url ? (
          <a href={row.invoice_url} target="_blank" rel="noreferrer">Abrir</a>
        ) : '-',
    },
  ];

  return (
    <div>
      <Title level={3}>Faturas</Title>
      <Space style={{ marginBottom: 16 }} wrap>
        <Select
          style={{ width: 180 }}
          value={status}
          onChange={(v) => { setStatus(v); setPage(1); }}
          options={STATUS_OPTIONS}
        />
        <Button icon={<SyncOutlined />} loading={syncing} onClick={handleSync}>
          Sincronizar Asaas
        </Button>
        <Button
          icon={<DownloadOutlined />}
          onClick={() => downloadOpsFaturasCsv({ status: status || undefined })}
        >
          Exportar CSV
        </Button>
      </Space>
      <Table
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={data.items}
        locale={{ emptyText: 'Nenhuma fatura. Clique em Sincronizar Asaas para importar o histórico.' }}
        pagination={{
          current: page,
          total: data.total,
          pageSize: 25,
          onChange: setPage,
        }}
      />
    </div>
  );
}
